import React, { Component } from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Panel, Radio, Checkbox, Row } from "react-bootstrap";

import {ethnicities, maritalOptions, statusTypes} from "../config/constants";
import FormSectionStatus from "./FormSectionStatus";

class DemographicInfo extends Component {
  constructor(props){
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleMaritalStatusChange = this.handleMaritalStatusChange.bind(this);
  }

  handleMaritalStatusChange(e) {
    if(this.props.readOnly)
      return;
    const updates = {
      maritalStatus: e.target.value
    };
    this.props.onChange(updates);
  }

  handleToggle(key) {
    if(this.props.readOnly)
      return;
    let updates = {};
    updates[key] = !this.props[key];
    this.props.onChange(updates);
  }

  render() {
    const {
      studentEthnicity,
      phones,
      address,
      email,
      deltaId,
      gender,
      name,
      maritalStatus,
      validationStatus,
      readOnly
    } = this.props;

    const mappedEthnicity = ethnicities.map(
      (ethnicity, index) => {
        return {
          name: ethnicity,
          checked: studentEthnicity.charAt(index) === 'Y',
          id: index
        }
      }
    );

    const renderEthnicities = () => {
      return (
        <Row>
          <FormGroup>
            <Col md={12}>
              <ControlLabel>Ethnicity</ControlLabel>
            </Col>
            <Col md={4}>
              {mappedEthnicity.filter((ethnicity, index) => index % 3 === 0).map(ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} disabled>{ethnicity.name}</Checkbox>)}
            </Col>
            <Col md={4}>
              {mappedEthnicity.filter((ethnicity, index) => index % 3 === 1).map(ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} disabled>{ethnicity.name}</Checkbox>)}
            </Col>
            <Col md={4}>
              {mappedEthnicity.filter((ethnicity, index) => index % 3 === 2).map(ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} disabled>{ethnicity.name}</Checkbox>)}
            </Col>
          </FormGroup>
        </Row>
      )
    };

    const renderMaritalStatus = () => {
      return (
        <FormGroup
          controlId='marital-status'
          validationState={validationStatus.maritalStatus}
        >
          <ControlLabel>
            Marital Status
          </ControlLabel>
          <Row>
            {maritalOptions.map((option) => {
              return (
                <Col sm={3} md={2} key={option.value}>
                  <Radio
                    name='maritalStatus'
                    inline
                    onChange={this.handleMaritalStatusChange}
                    value={option.value}
                    checked={maritalStatus === option.value}
                  >
                    {option.text}
                  </Radio>
                </Col>
              )
            })
            }
          </Row>
        </FormGroup>
      )
    };

    return (
      <Panel bsStyle={validationStatus.section.status}>
        <Panel.Heading>Demographic Information</Panel.Heading>
        <Panel.Body>
          <Row>
            <Col md={6}>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>
                  Delta Id
                </ControlLabel>
                <FormControl.Static>
                  {deltaId}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>
                  Gender
                </ControlLabel>
                <FormControl.Static>
                  {gender}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>
                  Student Email
                </ControlLabel>
                <FormControl.Static>
                  {email}
                </FormControl.Static>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>
                  First Name
                </ControlLabel>
                <FormControl.Static>
                  {name.firstName}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  Middle Name
                </ControlLabel>
                <FormControl.Static>
                  {name.middleName}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup>
                <ControlLabel>
                  Last Name
                </ControlLabel>
                <FormControl.Static>
                  {name.lastName}
                </FormControl.Static>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <ControlLabel>
                  Street Address
                </ControlLabel>
                <FormControl.Static>
                  {address.address1}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  City
                </ControlLabel>
                <FormControl.Static>
                  {address.city}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <ControlLabel>
                  State
                </ControlLabel>
                <FormControl.Static>
                  {address.state}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <ControlLabel>
                  Zip Code
                </ControlLabel>
                <FormControl.Static>
                  {address.zip}
                </FormControl.Static>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  Home Phone Number
                </ControlLabel>
                <FormControl.Static>
                  {phones.home || 'None Provided'}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  Cell Phone Number
                </ControlLabel>
                <FormControl.Static>
                  {phones.cell || 'None Provided'}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  Work Phone Number
                </ControlLabel>
                <FormControl.Static>
                  {phones.work || 'None Provided'}
                </FormControl.Static>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <ControlLabel>
                  Emergency Phone Number
                </ControlLabel>
                <FormControl.Static>
                  {phones.emergency || 'None Provided'}
                </FormControl.Static>
              </FormGroup>
            </Col>
          </Row>
          {renderEthnicities()}
          {renderMaritalStatus()}
          {!readOnly && validationStatus.section.status !== statusTypes.SUCCESS &&
          <FormSectionStatus {...validationStatus.section}/>
          }
        </Panel.Body>
      </Panel>
    )
  }
}

export default DemographicInfo